const lbBeamer = angular.module('app.lbBeamer', []);

lbBeamer.controller('lbBeamerCtrl', require('./lbBeamerCtrl'));
lbBeamer.directive('lbBeamer', require('./lbBeamerDir'));

export default lbBeamer;



// WEBPACK FOOTER //
// ./src/components/lbBeamer/index.js